import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import MetaInfo from "vue-meta-info";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./store/index";
import TDesign from "tdesign-vue";
// 引入组件库全局样式资源
import "tdesign-vue/es/style/index.css";

Vue.use(MetaInfo);
Vue.use(ElementUI);
Vue.use(TDesign);
Vue.config.productionTip = false;

for (const i in process.env) {
  window[i] = process.env[i];
}

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
